var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpisode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "269px",
    height: "110px",
    viewBox: "0 0 269 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0405_Renew",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buy-Fish/Logout",
    transform: "translate(-1048.000000, -205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1048.260023, 206.107398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(11.000000, 14.813679)",
    fill: "#030023"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55792708,12.7534845 L27.0106034,76.1287569 C27.7057842,77.9304931 29.3764094,79.1707992 31.3022216,79.3149417 L220.912425,93.5068119 C223.169899,93.6757784 225.259248,92.3069188 226.005861,90.1697934 L255.124655,6.81936108 C256.035392,4.2124434 254.660366,1.36082109 252.053448,0.450084385 C251.485681,0.251732721 250.886786,0.157440995 250.285538,0.171739723 L7.10386417,5.9550295 C4.34322099,6.02068247 2.15849976,8.3118482 2.22415273,11.0724914 C2.23783592,11.6478561 2.35075238,12.2165391 2.55792708,12.7534845 Z",
    id: "Path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 6.813679)",
    fill: "#3360FF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape",
    points: "54.7399772 65.0789226 132.739977 95.5761466 120.644799 101.078923 76.5275435 101.078923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11585415,19.3829971 L25.8086126,73.0134948 C27.2316514,76.7016583 30.6938376,79.2053311 34.6421446,79.4014452 L217.29066,88.4736743 C221.651538,88.6902809 225.648788,86.0525303 227.164704,81.9578782 L252.390823,13.819415 C254.308295,8.64011542 251.664062,2.88704502 246.484762,0.969572607 C245.298508,0.530399526 244.039702,0.320276733 242.775121,0.350350717 L14.2077283,5.78608706 C8.68644197,5.91739301 4.31699951,10.4997245 4.44830545,16.0210108 C4.47567183,17.1717402 4.70150476,18.3091062 5.11585415,19.3829971 Z",
    id: "Path-30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.494637,0 C194.23229,4.38302918 192.969943,8.76605836 191.707597,13.1490875",
    id: "Path-31",
    stroke: "#FFFFFF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.456976,19.7956872 C214.40769,15.1183345 220.358402,10.4409827 226.309116,5.76363006",
    id: "Path-33",
    stroke: "#FFFFFF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.194414,33.6648215 C218.942589,33.9114166 224.690763,34.1580117 230.438938,34.4046068",
    id: "Path-34",
    stroke: "#FFFFFF",
    strokeWidth: 8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisode);
export default __webpack_public_path__ + "static/media/episode.3f938b8b6215c72e4fc075adcc77e4a9.svg";
export { ForwardRef as ReactComponent };